export default "__VITE_ASSET__Spt417WD__"